import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFaceExtraHappy24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFaceExtraHappy24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8.75 11a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m7.75-1.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12 17c-1.371 0-2.69-.723-3.618-2h7.236c-.928 1.277-2.247 2-3.618 2m0 1.5c2.355 0 4.41-1.508 5.51-3.75.296-.601-.184-1.25-.854-1.25H7.344c-.67 0-1.15.649-.855 1.25C7.59 16.992 9.645 18.5 12 18.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFaceExtraHappy24);
